/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var moment = require("moment-timezone");

module.exports = Model({
	name: "schedulemaker",
	init: init,
	triggers: triggers,

	reset: reset,
});

var day_names = [
	"sun",
	"mon",
	"tue",
	"wed",
	"thu",
	"fri",
	"sat"
];

function init() {
	this.reset();
}

function reset() {
	this.push({
		day_names: day_names
	});
}

function triggers() {
	return {
		add: handle_add,
	};
}

function handle_add(data) {
	var cron = make_cron(data);
	var action = data.action;
	var timezone = moment.tz.guess();

	this.emit("schedules:trigger:add", {
		action: action,
		schedule: cron,
		timezone: timezone
	});
}

/**
 * Constructs a complete cron string.  Currently includes 'date' and 'month'
 * which are not used at the moment but may be required for future features.
 */
function make_cron(data) {
	var minute = data.time.minutes;
	var hour = data.time.hours;
	var dayOfMonth = "*";
	var month = "*";
	var day = data.day;
	var scheduleMonth = data.monthSwitch;
	var date = new Date(data.months);

	if(scheduleMonth){
		dayOfMonth = date.getUTCDate();
		month = date.getUTCMonth();
		day = "*";
	}

	return [minute, hour, dayOfMonth, month, day].join(" ");
}
